/** @jsxImportSource @emotion/react */
import { Typography, createStyles } from '@quickbit/qb-design-system';
import { type CorporateWalletTransactionMinimal } from 'api/walletApi.types';
import { TransactionList } from './components';
import { getTimeCategoryId } from './utils/getTimeCategoryId';

interface Props {
  transactions: CorporateWalletTransactionMinimal[];
  merchantId: string;
}

export const Transactions = ({ transactions, merchantId }: Props) => {
  const styles = useStyles();

  const groupedTransactions = transactions.reduce<
    Record<string, CorporateWalletTransactionMinimal[]>
  >((prev, curr) => {
    const timeCategory = getTimeCategoryId(new Date(curr.createdAt));
    const groupName =
      typeof timeCategory === 'string'
        ? timeCategory
        : `${timeCategory.month} ${
            timeCategory.year ? timeCategory.year.toString() : ''
          }`;

    return {
      ...prev,
      [groupName]: [...(prev[groupName] ?? []), curr],
    };
  }, {});

  const transactionsExists = Object.keys(groupedTransactions).length > 0;

  return (
    <div css={{ width: '100%' }}>
      {transactionsExists &&
        Object.keys(groupedTransactions).map((groupName: string) => (
          <div key={groupName}>
            <div css={styles.walletsTitle}>
              <Typography variant="subtitle">{groupName}</Typography>
            </div>
            <TransactionList
              merchantId={merchantId}
              transactions={groupedTransactions[groupName]}
            />
          </div>
        ))}
    </div>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  walletsTitle: {
    marginTop: spacing.xs,
  },
}));
